module.exports = __webpack_public_path__ + "static/media/folder-q-led_en.9993c526.pdf";